import store from '@/store'

function permission(el, { value, modifiers }) {
  // const btnRoles = store.state.admin.permission.btnRole
  // console.log(btnRoles)
  // const curr = btnRoles
  //   ? btnRoles.find((item) => item.buttonID === value)
  //   : null
  // console.log('xxxx->', curr, value)
  // if (!curr) {
  //   console.log('权限:', value, '没有')
  //   el.parentNode && el.parentNode.removeChild(el)
  // }
  // if (curr) {
  //   if (modifiers) {
  //     if (modifiers.append) {
  //       var text = document.createTextNode(curr.displayText)
  //       el.appendChild(text)
  //     }
  //   }
  // } else {
  //   el.parentNode && el.parentNode.removeChild(el)
  // }

  store.dispatch('admin/permission/getBtnRole').then((btnRoles) => {
    const curr = btnRoles
      ? btnRoles.find((item) => item.buttonID === value)
      : null
    if (!curr) {
      el.parentNode && el.parentNode.removeChild(el)
    }
    if (curr) {
      if (modifiers) {
        if (modifiers.append) {
          var text = document.createTextNode(curr.displayText)
          el.appendChild(text)
        }
      }
    } else {
      el.parentNode && el.parentNode.removeChild(el)
    }
  })
  // console.log(btnRoles)

  // const funcID = router.app.$route.meta.funcID
  // const menuMap = store.state.admin.menu.menuMap || {}
  // const menu = menuMap[funcID]
  // const btnRoles = menu ? menu.btnFunc || [] : []

  // const curr = btnRoles
  //   ? btnRoles.find((item) => item.buttonID === value)
  //   : null
  // if (curr) {
  //   if (modifiers) {
  //     if (modifiers.append) {
  //       var text = document.createTextNode(curr.displayText)
  //       el.appendChild(text)
  //     }
  //   }
  // } else {
  //   el.parentNode && el.parentNode.removeChild(el)
  //   // el.parentNode.style.display = 'none'
  // }
}

export default {
  install(Vue) {
    // v-allow=""
    Vue.directive('allow', {
      inserted(el, binding) {
        const { modifiers, value } = binding
        permission(el, { value, modifiers })
      }
    })
  }
}
